/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import { API_ROUTE, Routes } from "../../Helpers/Constants";
import AuthenticationContext from "../../Store/Authentication-Context";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import { loginAuthProvider } from "../../LoginAuthProvider";
import LogRocket from "logrocket";
import Axios from "axios";
import PricingModel from "./PricingModel";

const Pricing = (props) => {
    const pageName = props.page;
    const urlParams = new URLSearchParams(window.location.search);
    const { setAuthContext } = useContext(AuthenticationContext);
    const [isValid, setIsValid] = useState(false);
    const orgId = urlParams.get("orgId") ? urlParams.get("orgId") : "";


    const validateToken = async (event) =>{
        if (event) {
            event.preventDefault();
        }
        var tokenString = await setAuthContext("", new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };

         await Axios.get(API_ROUTE + Routes.VALIDATE_TOKEN + "/" + orgId, config)
            .then((response) => {

                let isValid = JSON.parse(response.data);
                if (isValid) {
                    setIsValid(true);
                } else {
                    window.location.href = "/login";
                }
            })
            .catch((reason) => {
                //console.log("catch" + reason);
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });

    }
    useEffect(() => {
        if (pageName === 'PricingModel') {
            validateToken();
        }
    }, []); 
    const renderContent = (authenticationState, accountInfo) => {
        if (pageName === 'PricingTool') {
            //return <PricingTool />;
            return <PricingModel page={props.page} />;
        }

        switch (authenticationState) {
            case AuthenticationState.Authenticated:
                LogRocket.identify(accountInfo.account.userName, {
                    name: accountInfo.account.name,
                });

                return (
                    <div>
                        {
                            pageName === 'PricingModel' && isValid ? <PricingModel page={props.page} /> : <div></div>
                        }
                    </div>
                );

            case AuthenticationState.Unauthenticated:
                window.location.href = "/login";
                return <div>Authentication Failed</div>;

            default:
                return <p>Please contact support.</p>;
        }
    };
    
    return (
        <>
            <AzureAD provider={loginAuthProvider} forceLogin={false}>
                {({ login, logout, authenticationState, error, accountInfo }) =>
                    renderContent(authenticationState, accountInfo)
                }
            </AzureAD>
        </>
    );
};

export default Pricing;